/*基础页面路由*/
let baserouter = [
    // 登录页面
    {
        path: '/login',
        name: 'login',
        meta: {
            title: '登录'
        },
        component: () => import('@/views/login')
    },

    // 注册页面
    {
        path: '/register',
        name: 'Register',
        meta: {
            title: '注册'
        },
        component: () => import('@/views/register')
    },

    // 重置密码
    {
        path: '/resetpassword',
        name: 'Resetpassword',
        meta: {
            title: '重置密码'
        },
        component: () => import('@/views/resetpassword')
    },
    {
        path: '/',
        redirect: {
            name: 'Home'
        },
        meta: {
            title: '母版'
        },
        component: () => import('@/views/layout2/main'),
        children: [
            {
                path: '/home',
                name: 'Home',
                meta: {
                    title: '首页'
                },
                component: () => import('@/views/home/home')
            },
            {
                path: '/major',
                name: 'Home',
                meta: {
                    title: '专业'
                },
                component: () => import('@/views/home/major')
            },
            {
                path: '/file',
                name: 'Home',
                meta: {
                    title: '附件'
                },
                component: () => import('@/views/home/file')
            },
        ]
    },
];

/*错误页面路由*/
export const errpage = [{
    path: '*',
    name: 'Page404',
    meta: {
        title: '错误页面'
    },
    component: () =>
        import('@/views/error-page/404')
}]

export default baserouter;



// WEBPACK FOOTER //
// ./src/router/baseRouter.js